<template>
    <div>
        <h5 class="mb-3">
            Hauptstandort
            <font-awesome-icon
                v-b-popover.hover.right="$t('intern_inserieren.hq_info')"
                icon="question-circle"
                class="mm-link"
                style="font-size: 11pt; margin-right:5px;"
            />

            <span class="text-muted font-10 mm-link" @click="chooseObject">Daten übernehmen</span>
        </h5>
        <div class="form-group mb-5">
            <div class="input-group">
                <input type="text" :class="{'is-invalid': error_plz}" class="form-control" @input="getPlz()" v-model="plz" placeholder="PLZ" @blur="clearLocations()">
                <input type="text" :class="{'is-invalid': error_plz}" class="form-control border-round" v-model="ort" placeholder="Ort">
                <div class="invalid-feedback" v-if="error_plz">Bitte geben Sie eine gültige PLZ ein.</div>
            </div>
        </div>

        <div style="position: relative">
            <ul class="list-group auto-complete" v-if="locations">
                <li class="list-group-item" v-for="loc in locations" :key="loc.id" @click="selectPlz(loc.zip_code, loc.city, loc.id)">
                    {{loc.zip_code}} {{loc.city}}
                </li>
            </ul>
        </div>

        <div v-if="!immobilien" class="">
            <h5 class="my-3 ">{{$t('intern_inserieren.umkreis')}}</h5>
            <div class="form-group mb-5">
                <select class="form-control" v-model="geo_radius">
                    <option value="50" selected="selected" :disabled="perimeter != 0 && perimeter < 50" :class="{'disabled' : perimeter != 0 && perimeter < 50}">Bis 50 km</option>
                    <option value="100" :disabled="perimeter != 0 && perimeter < 100" :class="{'disabled' : perimeter != 0 && perimeter < 100}">Bis 100 km</option>
                    <option value="200" :disabled="perimeter != 0 && perimeter < 200" :class="{'disabled' : perimeter != 0 && perimeter < 200}">Bis 200 km</option>
                    <option value="500" :disabled="perimeter != 0 && perimeter < 500" :class="{'disabled' : perimeter != 0 && perimeter < 500}">Bis 500 km</option>
                    <option value="999" :disabled="perimeter != 0 && perimeter < 999" :class="{'disabled' : perimeter != 0 && perimeter < 999}">Deutschlandweit</option>
                </select>
            </div>
            <h5 class="my-3">
                Wählen Sie hier optional eine Zusatzangabe aus, die im Inserat veröffentlicht werden soll
                <font-awesome-icon
                    v-b-popover.hover.right="$t('intern_inserieren.delivery_info')"
                    icon="question-circle"
                    class="mm-link"
                    style="font-size: 11pt;"
                />
            </h5>
            <div class="form-group">
                <div>
                  <span @click="assignDelivery('versand')" class="pointer">
                      <font-awesome-icon icon="check-square" v-if="delivery =='versand'"/>
                      <font-awesome-icon icon="square" v-else/>
                  </span>
                  Deutschlandweiter Versand
                </div>

                <div>
                  <span @click="assignDelivery('anlieferung')" class="pointer">
                    <font-awesome-icon icon="check-square" v-if="delivery == 'anlieferung'"/>
                    <font-awesome-icon icon="square" v-else/>
                  </span>
                  Lieferung im angegebenen Umkreis
                </div>

                <div>
                  <span @click="assignDelivery('einsatzgebiet')" class="pointer">
                      <font-awesome-icon icon="check-square" v-if="delivery == 'einsatzgebiet'"/>
                      <font-awesome-icon icon="square" v-else/>
                  </span>
                  Anreise im angegebenen Umkreis
                </div>

                <div>
                  <span @click="assignDelivery('abholung')" class="pointer">
                      <font-awesome-icon icon="check-square" v-if="delivery == 'abholung'"/>
                      <font-awesome-icon icon="square" v-else/>
                  </span>
                  Abholung vor Ort
                </div>

                <div>
                  <span @click="assignDelivery('keine_angabe')" class="pointer">
                      <font-awesome-icon icon="check-square" v-if="delivery == 'keine_angabe' || delivery == ''"/>
                      <font-awesome-icon icon="square" v-else/>
                  </span>
                  Keine Zusatzangabe
                </div>

            </div>
            <template v-if="$store.state.user && $store.state.user.multi_geo == 'ja'">
                <h5 class="my-3">
                    {{$t('intern_inserieren.weiterer_standort')}}
                    <font-awesome-icon
                        v-b-popover.hover.right="$t('intern_inserieren.infoplz')"
                        icon="question-circle"
                        class="mm-link"
                        style="font-size: 11pt; margin-right:5px;"
                    />
                </h5>
                <div class="form-group">
                    <input class="form-control" v-model="plz_2" @input="getPlz(false)" @blur="clearLocations()" placeholder="PLZ / Ort">
                </div>
                <div style="position: relative">
                    <ul class="list-group" v-if="extra_locations">
                        <li class="list-group-item" v-for="loc in extra_locations" :key="loc.id" @click="addExtraPlz(loc.zip_code, loc.city, loc.id)">
                            {{loc.zip_code}} {{loc.city}}
                        </li>
                    </ul>
                </div>
                <div v-if="extra_plz.length > 0">
                    <template v-for="area in extra_plz">
                        <p :key="area.code" v-if="area.code != id">
                            {{area.zip}} {{area.city}}
                            <span @click="deleteLocation(area.code)" class="circle bg-danger">&times;</span>
                        </p>
                    </template>
                </div>
            </template>
        </div>
        <div v-if="isMobile" class="mt-3 text-center">
            <button v-if="create" class="btn btn-success w-100" @click="validateOrtBackEnd(weiter)">Weiter</button>
            <button v-if="!create" class="btn btn-success mb-1 w-100" @click="validateOrtBackEnd(save(true))">Speichern und Schließen</button>
            <button v-if="!create" class="btn btn-success w-100" @click="validateOrtBackEnd(save)">Weiter</button>
        </div>
        <div v-else class="mt-3 text-right">
            <button v-if="create" class="btn btn-success" @click="validateOrtBackEnd(weiter)">Weiter</button>
            <button v-if="!create" class="btn btn-success mx-2" @click="validateOrtBackEnd(save(true))">Speichern und Schließen</button>
            <button v-if="!create" class="btn btn-success" @click="validateOrtBackEnd(save)">Weiter</button>
        </div>
        <b-modal ref="error-modal" :title="'Fehlermeldung'">
            <div class="d-block">
                <h5>{{$t('intern_object_erstellen.location_error')}}</h5>
            </div>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button variant="danger" @click="cancel()">Schließen</b-button>
            </template>
        </b-modal>
        <b-modal ref="choose-object-modal" :title="'Wählen Sie das Inserat, wovon Sie die Standortangaben übernehmen möchten.'" size="lg">
            <div class="d-block">
                <ul class="list-group" v-if="tinyObjects && tinyObjects.length > 0">
                    <li class="list-group-item text-truncate"
                        v-for="object in tinyObjects"
                        :key="object.id"
                        @click="fetchGeoCodes(object.id)">Nummer {{object.id}} - {{object.name}}</li>
                </ul>
                <div class="alert alert-warning" v-else>Sie haben keine Inserate, wovon Sie die Daten übernehmen können.</div>
            </div>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button variant="secondary" @click="cancel()">Schließen</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Inserat from '../../../classes/Inserat';
import { IsMobileMixin } from '../../../mixins/IsMobile';

    export default {
        data() {
            return {
                plz         : null,
                ort         : null,
                id          : null,
                geo_radius  : 50,
                delivery    : 'keine_angabe',
                locations   : [],
                plz_2       : null,
                extra_plz   : [],
                tinyObjects : [],
                error_plz   : false,
                immobilien  : false,
                extra_locations: [],
                perimeter : ''
            }
        },
        mixins: [IsMobileMixin],
        watch: {
            delivery: {
                deep: true,
                handler() {

                }
            }
        },
        props:['create'],
        methods: {
            scrollTop() {
                window.scrollTo(0, 0);
            },
            chooseObject() {
                this.tinyObjects = this.$store.getters.tinyObjects.all;
                this.$refs['choose-object-modal'].show();
            },
            fetchGeoCodes(id) {
                this.$http.get('/objectApi/getLocationOfObject?object_id='+id).then( response => {
                    let data        = JSON.parse(response.data);
                    this.id         = data.main_plz.id;
                    this.plz        = data.main_plz.plz;
                    this.ort        = data.main_plz.city;
                    this.extra_plz  = data.extra_plz;
                    this.assignDelivery(data.delivery);
                    this.geo_radius = data.geo_radius;

                    this.$refs['choose-object-modal'].hide();
                }).catch( error => {
                    console.log(error);
                });
            },
            getPlz(main_location = true) {
                if(main_location){
                    this.$http.get('/objectApi/getPlz?term='+this.plz).then((response) => {
                        this.locations = JSON.parse(response.data);
                        if(this.locations) this.error_plz = false;
                    });
                }else {
                    this.$http.get('/objectApi/getPlz?term='+this.plz_2).then((response) => {
                        this.extra_locations = JSON.parse(response.data);
                        if(this.extra_locations) this.error_plz = false;
                    });
                }
            },
            selectPlz(plz, city, id) {
                this.plz = plz;
                this.ort = city;
                this.id  = id;
                this.locations = [];
            },
            addExtraPlz(plz, city, id) {
                this.extra_plz.push({
                    code: id,
                    zip: plz,
                    city
                });
                this.extra_locations = [];
            },
            deleteLocation(area_code){
                this.extra_plz = this.extra_plz.filter( area => area.code != area_code );
            },
            clearLocations() {
                setTimeout(() => { this.locations = []; this.extra_locations = []; this.plz_2 = null;}, 500);
            },
            validate() {
                if(!this.plz || !this.ort || !this.geo_radius){
                    return false;
                }
                return true;
            },
            validateOrtBackEnd(fn) {
                this.$store.state.loading = true;
                this.error_plz = false;

                this.$http.get(`/objectApi/validateOrt?ort=${this.ort}&plz=${this.plz}`).then(response => {
                    this.id = response.data;
                }).catch(() => {
                    this.error_plz = true;
                }).then(() => {
                    this.$store.state.loading = false;
                    if(!this.error_plz)
                        fn();
                });
            },
            weiter(gotoNextTab = true) {
                if(this.validate()){
                    let inserat = Inserat.getObjectFromJSON(JSON.parse(localStorage.getItem('currentObject')));
                    //let delivery = Object.entries(this.delivery);
                    //delivery     = delivery.filter(item => item[1]).map(item => item[0]).join('>>');

                    inserat.setPlz(this.plz);
                    inserat.setOrt(this.ort);
                    inserat.setGeoId(this.id);
                    inserat.setGeoRadius(this.geo_radius);
                    inserat.setDelivery(this.delivery);
                    inserat.setExtraPlz(this.extra_plz);

                    localStorage.setItem('currentObject', JSON.stringify(inserat));
                    if(gotoNextTab){
                        localStorage.setItem('currentObjectTab', 'contact');
                        this.$emit('nextTab','contact');
                    }

                }else{
                    this.$refs['error-modal'].show();
                }
            },
            save(closeAfter = false) {
                //let delivery = Object.entries(this.delivery);
                //delivery     = delivery.filter(item => item[1]).map(item => item[0]).join('>>');

                if(this.validate()){
                    let object = this.$store.state.editObject;
                    object.district_id = this.id;
                    object.geo_radius  = this.geo_radius;

                    object.delivery    = this.delivery != '' ? this.delivery : 'keine_angabe';
                    object.zip_code    = this.plz ;
                    object.city        = this.ort;
                    object.extra_plz   = this.extra_plz;

                    this.$store.state.loading = true;

                    this.$http.put('/objectApi/updateObject?id='+object.id, object).then(response => {
                        this.$store.state.editObject = object;
                        this.$store.state.loading = false;
                        this.$emit('success', response.data);
                        if(closeAfter){
                            setTimeout(() => {
                                this.$router.push({name: 'inserat-uebersicht', params: {page: this.$store.state.lastOpenedPage}});
                            },1000 );
                        }
                        else {
                          this.$emit('nextTab', 'contact');
                        }

                    }).catch(error => {
                        this.$store.state.loading = false;
                        this.$emit('error', error.response.data.data);
                    });
                }else{
                    this.$refs['error-modal'].show();
                }
            },
            assignDelivery(key) {
              if(key == '')  key = 'keine_angabe';
              this.delivery = key;

              this.$forceUpdate();
            }
        },
        created() {
            this.scrollTop();
            let category_id;
            if(this.create){
                let jsonObject = JSON.parse(localStorage.getItem('currentObject'));
                let inserat = Inserat.getObjectFromJSON(jsonObject);
                category_id = inserat.getCategoryId();

                if(inserat.getGeoId()){
                    this.id = inserat.getGeoId();
                }
                if(inserat.getPlz()){
                    this.plz = inserat.getPlz();
                }
                if(inserat.getOrt()){
                    this.ort = inserat.getOrt();
                }
                if(inserat.getGeoRadius()){
                    this.geo_radius = inserat.getGeoRadius();
                }
                if(inserat.getDelivery()){
                    this.delivery   = '';
                    this.delivery = inserat.getDelivery();
                }
                if(inserat.getExtraPlz()){
                    this.extra_plz = inserat.getExtraPlz();
                }
            }else {
                let object       = this.$store.state.editObject;
                category_id      = object.category_id;
                this.plz         = object.zip_code;
                this.ort         = object.city;
                this.id          = object.district_id;
                this.geo_radius  = object.geo_radius;
                this.delivery    = object.delivery;

                if(this.$store.state.user.multi_geo && this.$store.state.user.multi_geo == 'ja'){
                    this.$http.get('objectApi/getGeoLocations?object_id='+object.id).then( response => {
                        this.extra_plz = JSON.parse(response.data);
                    }).catch( error => {
                        console.log(error);
                    });
                }
            }

            this.$http.get('/CategoryApi/isImmobilien?category_id=' + category_id).then( response => {
                this.immobilien = response.data;

                if(this.immobilien) {
                    this.geo_radius = 50;
                }
            }).catch( error => {
                console.log(error);
            });

            this.$http.get('/UserPacketApi/UserPerimeter').then( response => {
                this.perimeter = response.data;
            }).catch( error => {
                console.log(error);
            });
        },
        beforeDestroy() {
          if(this.create){
            this.weiter(false);
          }
        }
    }
</script>

<style scoped>
.list-group.auto-complete{
    max-height: 400px;
    position: absolute;
    top: -15px;
    left: 0;
    overflow: auto;
    width: 300px;
    z-index: 10;
}
.list-group-item{
    cursor: pointer;
}
.circle{
    cursor: pointer;
    width: 25px;
    height: 25px;
    padding: 2px 6px;
    border: 0;
    border-radius: 50%;
    color: white;
}
.is-invalid.border-round{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
}
.disabled{
  color: #c4c0c0 !important;
}
</style>
